/**
 * Route for `advertiser-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserApiPage } from "../features/advertiser-api/AdvertiserApiPage";

export const advertiserApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-api",
	component: AdvertiserApiPage,
});

export default advertiserApiRoute;
